import React from 'react';
import InlineError from 'react/elements/InlineError';
import { __ } from 'i18n/index';
import { stripeCheckout } from 'components/StripeSubscribe';
import { isNetplayPageActive } from 'react/netplay/netplayPageState';
import { assignPage } from 'navigation/pageLocation';
import ActiveSelectableButton from "../elements/ActiveSelectableButton";

export class SubscribeButtonComponent extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			step: 2,
			paying: false,
			stripeError: null,
		};

		this.onStep1Click = this.step1Click.bind(this);
		this.onStep2Click = this.step2Click.bind(this);


	}

	stripeSubscribeClick(product, amount, description) {
		this.setState({ paying: true, stripeError: null });
		return stripeCheckout({ product, amount, description, gifted: this.props.player.id })
			.then((response) => {
				if(response && response.redirect && !isNetplayPageActive()) {
					assignPage(myUser.getProfileUrl() + '/subscriptions');
				}
			})
			.catch((error) => {
				this.setState({ stripeError: error.message || __('Something went wrong. Please try again.') });
			})
			.finally(() => {
				this.setState({ paying: false });
			});
	}

	step1Click(e) {
		this.setState({
			step: 2
		});

		this.props.onActivate();

	}

	step2Click(type, e) {
		this.setState({
			type: type,
			step: 3
		});
	}

	render() {
		if(!this.props.player) {
			return null;
		}

		const player = this.props.player;
		const paypalGiftData = JSON.stringify({
			version: 2,
			gift_player_id: myUser.id,
			player_id: player.id,
		});

		const oneMonthDescription = __('Gift 1 Month Sub to %s ($5.99)', player.username);
		const oneYearDescription = __('Gift 1 Year Sub to %s ($50.00)', player.username);

		const oneMonthPaypalDescription = __('%s from %s', oneMonthDescription, myUser.username);
		const oneYearPaypalDescription = __('%s from %s', oneYearDescription, myUser.username);

		return (
			<div className='subscribe'>
				{!player.isMe() &&
				<div className='gift_steps'>
					{this.state.step === 1 &&
					<div className='gift_step' onClick={this.onStep1Click}>
						<ActiveSelectableButton className='btn shadowed-btn gift_subscription sub_beg'>
							<span>{__('Gift Sub')}</span>
						</ActiveSelectableButton>
					</div>
					}
					{this.state.step === 2 &&
					<div className='gift_step'>
						<ActiveSelectableButton data-month='1' className='btn btn-sm btn-success'
						        onClick={this.onStep2Click.bind(null, 'one_month')}>{__('+1 Month')}
						</ActiveSelectableButton>
						<ActiveSelectableButton data-year='1' className='btn btn-sm btn-success'
						        onClick={this.onStep2Click.bind(null, 'one_year')}>{__('+1 Year')}
						</ActiveSelectableButton>
					</div>
					}
					{this.state.step === 3 && this.state.type == 'one_month' &&
					<div className='one_month gift_step'>
						<ActiveSelectableButton className='btn-sm btn payment-submit btn-success'
						        disabled={this.state.paying}
						        onClick={() => this.stripeSubscribeClick('1-month-gift-subscription', 599, oneMonthDescription)}
						>{__('$5.99 Stripe Checkout')}
						</ActiveSelectableButton>
						<InlineError message={this.state.stripeError} />
						<form className='paypal_form' action={subscriptionPaypalUrl}
						      method="post" target="_blank">
							<input type="hidden" name="cmd" value="_s-xclick" />
							<input type='hidden' name='item_name'
							       value={oneMonthPaypalDescription} />
							<input type="hidden" name="hosted_button_id"
							       value={paypalGiftSubCode} />
							<input type="hidden" name="custom"
							       value={paypalGiftData}
							/>
							<input type="hidden" name="notify_url"
							       value={subscriptionSiteHost + '/payment/paypal_listener'} />
							<ActiveSelectableButton
								className='btn btn-success btn-sm'
								type='submit'>
								$5.99{' '} {__('w/')} <i className='fa fa-paypal' />
							</ActiveSelectableButton>
						</form>
					</div>
					}
					{this.state.step === 3 && this.state.type === 'one_year' &&
					<div className='one_year gift_step'>
						<ActiveSelectableButton
							disabled={this.state.paying}
							onClick={() => this.stripeSubscribeClick('1-year-gift-subscription', 5000, oneYearDescription)}
							className='btn-sm btn payment-submit btn-success'
						>{__('$50.00 Stripe Checkout')}
						</ActiveSelectableButton>
						<InlineError message={this.state.stripeError} />
						<form className='paypal_form' action={subscriptionPaypalUrl} method="post"
						      target="_blank">
							<input type="hidden" name="cmd" value="_s-xclick" />
							<input type='hidden' name='item_name'
							       value={oneYearPaypalDescription} />
							<input type="hidden" name="hosted_button_id"
							       value="SJHFF6AU2JXEN" />
							<input type="hidden" name="custom"
							       value={paypalGiftData}
							/>
							<input type="hidden" name="notify_url"
							       value={subscriptionSiteHost + '/payment/paypal_listener'} />
							<ActiveSelectableButton
								className='btn btn-success btn-sm'
								type='submit'>
								$50.00{' '} {__('w/')} <i className='fa fa-paypal' />
							</ActiveSelectableButton>
						</form>
					</div>
					}
				</div>
				}
			</div>
		);
	}
}

SubscribeButtonComponent.defaultProps = {
	onClick: () => {
	}
};